<template>
  <div id="app">
        <div class="app-content">
          <router-view :key="'main-content'+$router.fullPath"/>
        </div>
  </div>
</template>

<style lang='scss'>
  @import './sass/index';
</style>

<script>

export default {
	data () {
		return {

    }
  }
};
</script>
